import * as React from 'react';
import DashboardLayout from '../../../shared/LayoutContainers/DashboardLayout';
import DashboardNavbar from '../../../shared/Navbars/DashboardNavbar';
import CadContratacaoV2Form from './CadContratacaoV2Form';

function CadContratacaoV2Screen() {
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <CadContratacaoV2Form />
    </DashboardLayout>
  );
}

export default CadContratacaoV2Screen;
